import * as React from 'react';
import { Elements } from '../../../utils/Stripe';
import InjectedPaymentForm, {
  PaymentForm,
  PaymentFormProps
} from './PaymentForm';

export interface CheckoutProps extends PaymentFormProps {
  forwardRef?: React.RefObject<{
    getWrappedInstance(): PaymentForm | undefined;
  }>;
}

export interface CheckoutState {
  /* empty*/
}

export class Checkout extends React.Component<CheckoutProps, CheckoutState> {
  render() {
    return (
      <Elements
        fonts={[
          {
            cssSrc:
              'https://fonts.googleapis.com/css?family=Roboto+Condensed:400,700|Roboto:400,500'
          }
        ]}
      >
        <InjectedPaymentForm {...this.props} ref={this.props.forwardRef} />
      </Elements>
    );
  }
}

export default Checkout;



// WEBPACK FOOTER //
// ./src/app/components/Premium/Checkout/index.tsx